import React from 'react'
import PropTypes from 'prop-types'
import { View } from 'components/View'
import Block from 'components/Block'
import TextTitleCompressedHeavy from 'components/TextTitleCompressedHeavy'
import TextBodySmaller from 'components/TextBodySmaller'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { useTheme } from 'modules/styles'
import markdownToHtmlStringUtil from 'utils/string/markdown-to-html'

const messages = defineMessages({
  heading: {
    id: 'CheckExerciseFormSlug.WhyFormMatters.heading',
    defaultMessage: 'Why Proper Form Matters for {exerciseName}'
  },
  paragraph1: {
    id: 'CheckExerciseFormSlug.WhyFormMatters.paragraph1',
    defaultMessage: 'Proper form is crucial for maximizing the effectiveness of {exerciseName}. When you perform exercises with correct technique, you ensure that the target muscles are properly activated and engaged throughout the movement.'
  },
  paragraph2: {
    id: 'CheckExerciseFormSlug.WhyFormMatters.paragraph2',
    defaultMessage: 'Poor form not only reduces the benefits of your workout but also significantly increases your risk of injury. Using our AI form checker helps you maintain proper technique, prevent common mistakes, and achieve better results from your training sessions.'
  }
})

export function WhyFormMatters ({ exerciseName, content }) {
  const intl = useIntl()
  const theme = useTheme()

  // Use database content if available, otherwise fallback to template
  const hasContent = !!content

  console.log('[WhyFormMatters] exerciseName:', exerciseName)
  console.log('[WhyFormMatters] hasContent:', hasContent)
  console.log('[WhyFormMatters] content:', content)

  return (
    <Block bgc='white'>
      <View
        centered
        style={{
          maxWidth: theme.maxWidth.desktopCompact
        }}
      >
        <View mb={2}>
          <TextTitleCompressedHeavy style={{ textAlign: 'center' }}>
            {formatMessageIntlUtil(intl, messages.heading, { exerciseName })}
          </TextTitleCompressedHeavy>
        </View>

        {hasContent
          ? (
            <div
              style={{ color: theme.colors.paragraph, textAlign: 'center' }}
              dangerouslySetInnerHTML={{
                __html: markdownToHtmlStringUtil(content)
              }}
            />
            )
          : (
            <>
              <View mb={2}>
                <TextBodySmaller
                  style={{
                    color: theme.colors.paragraph,
                    textAlign: 'center'
                  }}
                >
                  {formatMessageIntlUtil(intl, messages.paragraph1, { exerciseName })}
                </TextBodySmaller>
              </View>

              <View>
                <TextBodySmaller
                  style={{
                    color: theme.colors.paragraph,
                    textAlign: 'center'
                  }}
                >
                  {formatMessageIntlUtil(intl, messages.paragraph2)}
                </TextBodySmaller>
              </View>
            </>
            )}
      </View>
    </Block>
  )
}

WhyFormMatters.propTypes = {
  exerciseName: PropTypes.string.isRequired,
  content: PropTypes.string
}
